import moment from 'moment'
import config from '@/config'
import PropTypes from 'prop-types'

const EMPTY_PROP = '-'
const DATE_FORMAT = config.dateFormat.client

export const DateAmountCell = (props) => {
  const { value } = props
  const formattedValue = value !== null && moment(value).isValid() ? moment(value).format(DATE_FORMAT) : EMPTY_PROP
  return formattedValue
}

DateAmountCell.propTypes = {
  value: PropTypes.any,
}

export default DateAmountCell
